// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1eG0q","footer":"ReportModalFilter_footer__2OPtB"};